import React, { useState } from 'react';
import { DashboardHeader, DashboardTab } from '../components/DashboardHeader';
import { ActivityMetrics } from '../components/ActivityMetrics';
import { ConversionFunnel } from '../components/ConversionFunnel';
import { PerformanceProjections } from '../components/PerformanceProjections';
import { UrgentActionTiles } from '../components/UrgentActionTiles';
import { PipelineTiles } from '../components/PipelineTiles';
import { OpportunitiesTiles } from '../components/OpportunitiesTiles';
import { Leaderboard } from '../components/Leaderboard';
import { HistoricalPerformanceTab } from '../components/HistoricalPerformanceTab';
import { mockDataByTimeframe, Timeframe } from '../data/mockData';
export function WarRoomDashboard() {
  const [timeframe, setTimeframe] = useState<Timeframe>('Today');
  const [activeTab, setActiveTab] = useState<DashboardTab>('current');
  const data = mockDataByTimeframe[timeframe];
  return <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-cyan-500/30" data-id="element-390">
      <DashboardHeader timeframe={timeframe} setTimeframe={setTimeframe} activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-391" />

      <main className="p-4 sm:p-6 max-w-[1600px] mx-auto space-y-6" data-id="element-392">
        {activeTab === 'current' ? <div className="space-y-6 animate-in fade-in duration-300" data-id="element-393">
            {/* Row 1: Leaderboard */}
            <Leaderboard leaderboard={data.leaderboard} data-id="element-394" />

            {/* Row 2: Core Activity Metrics */}
            <ActivityMetrics metrics={data.metrics} data-id="element-395" />

            {/* Row 3: Funnel & Projections */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-id="element-396">
              <div className="lg:col-span-7" data-id="element-397">
                <ConversionFunnel funnel={data.funnel} data-id="element-398" />
              </div>
              <div className="lg:col-span-5" data-id="element-399">
                <PerformanceProjections projections={data.projections} data-id="element-400" />
              </div>
            </div>

            {/* Row 4: Urgent Actions */}
            <UrgentActionTiles urgentActions={data.urgentActions} data-id="element-401" />

            {/* Row 5: Pipeline & Fundings */}
            <PipelineTiles pipeline={data.pipeline} data-id="element-402" />

            {/* Row 6: Opportunities */}
            <OpportunitiesTiles opportunities={data.opportunities} data-id="element-403" />
          </div> : <HistoricalPerformanceTab data-id="element-404" />}
      </main>
    </div>;
}